import axios from "axios";
import React, { useEffect, useState } from "react";
import "./memberinfo.scss";
import ModalUmum from "../../../modalUmum/ModalUmum";
import moment from "moment";

function Memberinfo() {
  const id = JSON.parse(window.localStorage.getItem("logId"));
  const idStaff = window.sessionStorage.getItem("dataLogin");
  const [data, setData] = useState(false);
  const [catatan, setcatatan] = useState(false);
  const [inputNote, setinputNote] = useState(false);
  const [inputKey, setinputKey] = useState(false);
  const [staff, setStaff] = useState();
  const [modalShow, setModalShow] = useState(false);

  //get staff by id
  const getStaffById = async () => {
    const rest = axios.create({
      baseURL: "https://mobile.amospa.com",
      headers: { Authorization: `Bearer ${idStaff}` },
    });
    const id = await rest.get("/jwt/token");
    let result = await axios.get(
      `https://mobile.amospa.com/staff/${id.data.data}`
    );
    setStaff(result.data.data[0]);
  };

  const getData = async () => {
    const result = await axios.get(`https://mobile.amospa.com/users/${id}`);
    setData(result.data.data[0]);
  };

  const getNote = async () => {
    const result = await axios.get(`https://mobile.amospa.com/note/user/${id}`);
    const lastNote = result.data.data.length;
    setcatatan(result.data.data[lastNote - 1]);
  };

  const lastScan = new Date();

  const postNote = async () => {
    await axios.post(`https://mobile.amospa.com/note`, {
      userId: id,
      staffName: staff.name,
      keterangan: "Chekin",
      catatan: inputNote,
      lastScan: lastScan,
      visit: catatan?.visit + 1,
    });

    await axios.post("https://mobile.amospa.com/checkin", {
      name: data.name,
      in: lastScan,
      out: false,
      mode: "Checkin",
      notes: inputNote,
      key: inputKey
    });

    // await axios.post("https://mobile.amospa.com/newmember", {
    //   name: data.name,
    //   in: lastScan,
    //   out: false,
    //   mode: "Checkin",
    //   notes: inputNote,
    // });

    setModalShow(true);
  };

  //Handle Next
  const handleNext = async () => {
    setModalShow(false);
  };

  useEffect(() => {
    getData();
    getNote();
    getStaffById();
  }, [modalShow]);


  return (
    <div className="memberInfo">
      <div className="headerInfo">
        <span>Notes : </span>
        <input
          type="text"
          name="catatan"
          onChange={(e) => setinputNote(e.target.value)}
        />
        <span className="ms-4">Key :</span>
        <input
          type="text"
          name="catatan"
          className="me-2"
          onChange={(e) => setinputKey(e.target.value)}
        />
        <button onClick={() => postNote()} className="bg-dark">
          Checkin
        </button>
      </div>
      <div className="contentInfo">
        <div className="row">
          <div className="col-8">
            <div className="leftInfo-memberLog">
              <table>
                <tbody>
                  <tr>
                    <td>Expired</td>
                    <td> :</td>
                    <td>{data ? moment(data.expired).parseZone().format('DD-MM-YYYY') : ""}</td>
                  </tr>
                  <tr>
                    <td>Last Scan</td>
                    <td> :</td>
                    <td>{catatan?.lastScan ? moment(catatan.lastScan).parseZone().format('DD-MM-YYYY') : ""}</td>
                  </tr>
                  <tr>
                    <td>Last Notes</td>
                    <td> :</td>
                    <td>{catatan ? catatan?.catatan : ""}</td>
                  </tr>
                  <tr>
                    <td>Visit</td>
                    <td> :</td>
                    <td>{catatan?.visit}</td>
                  </tr>
                  <tr>
                    <td>Discount</td>
                    <td> :</td>
                    <td>{data ? data?.discount : ""}</td>
                  </tr>
                  <tr>
                    <td>Point</td>
                    <td> :</td>
                    <td>{data ? data?.point : ""}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="col-4 rigthInfo">
            <div className="imageInfo">
              <img src={data ? data?.image : ""} alt="" />
            </div>
          </div>
        </div>
      </div>
      <ModalUmum
        show={modalShow}
        onHide={() => setModalShow(false)}
        title="Checkin Success"
        nextButton={handleNext}
      />
    </div>
  );
}

export default Memberinfo;
